import { APP_NAME, SUPPORT_EMAIL } from "../app.constants";

export interface SeoPage {
  title: string;
  eyebrow: string;
  description: string;
  sections: { title: string; text: string }[];
}

export const SEO_BLOG_PAGES: Record<string, SeoPage> = {
  "cookie-policy": {
    eyebrow: "TRANSPARENCY",
    title: `Cookie policy`,
    description: `Learn how ${APP_NAME} uses cookies and similar technologies to operate and improve the service.`,
    sections: [
      {
        title: `Essential storage only`,
        text: `${APP_NAME} uses browser local storage to save your chat session within the current browser. No advertising cookies are used.`,
      },
      {
        title: `No third-party tracking`,
        text: "We do not use third-party analytics or advertising cookies that track you across websites.",
      },
      {
        title: `Control your storage`,
        text: `Clear your browser's local storage at any time to remove all ${APP_NAME} data from your device.`,
      },
    ],
  },
  dmca: {
    eyebrow: `COPYRIGHT`,
    title: `Copyright and DMCA`,
    description: `Information for submitting a copyright concern about content that may appear on ${APP_NAME}.`,
    sections: [
      {
        title: `Report a copyright concern`,
        text: `If you believe content on StrangerYap infringes your copyright, contact us at ${SUPPORT_EMAIL} with full details of the alleged infringement.`,
      },
      {
        title: "What to include",
        text: "Your DMCA notice should identify the copyrighted work, describe where the infringing content appears, and include your contact details.",
      },
      {
        title: "Response time",
        text: "We aim to acknowledge valid DMCA notices within 5 business days and take appropriate action as required by law.",
      },
    ],
  },
  "blog/ometv-alternatives": {
    eyebrow: "GUIDE",
    title: "OmeTV alternatives for meeting people online",
    description:
      "Explore what to look for in a random chat service, from privacy and moderation to the quality of conversations.",
    sections: [
      {
        title: "What makes a good random chat site",
        text: "The best alternatives to OmeTV offer privacy-first design, interest matching, and clear safety controls.",
      },
      {
        title: "Why text-first chat works",
        text: `Starting with text removes camera pressure and lets the conversation find its own pace.`,
      },
      {
        title: `Try ${APP_NAME}`,
        text: `${APP_NAME} is a free, anonymous text-chat platform with interest-based matching and no account required.`,
      },
    ],
  },
  "blog/best-websites-to-chat-with-strangers": {
    eyebrow: "GUIDE",
    title: "The best websites to chat with strangers",
    description:
      "A practical guide to choosing a random chat website that fits your interests and comfort level.",
    sections: [
      {
        title: "Privacy first",
        text: "The best stranger-chat sites never ask for personal details and give you real control over who you talk to.",
      },
      {
        title: "Interest matching",
        text: "Sites that match by interests produce better conversations because both people already have something in common.",
      },
      {
        title: "Simple moderation tools",
        text: "Look for platforms where blocking and reporting are easy and effective — not buried in menus.",
      },
    ],
  },
  "blog/how-to-talk-to-a-stranger-online": {
    eyebrow: "GUIDE",
    title: "How to talk to a stranger online",
    description:
      "Simple conversation starters and safety habits that make meeting someone new feel natural.",
    sections: [
      {
        title: "Start with shared interests",
        text: "The easiest conversation opener is a topic you both enjoy. Interest matching takes care of this automatically.",
      },
      {
        title: "Ask open questions",
        text: "Questions that invite a story — 'what kind of music do you make?' — go further than yes/no openers.",
      },
      {
        title: "Stay safe",
        text: "Keep personal details private until you are comfortable. Trust your instincts and leave any conversation that feels wrong.",
      },
    ],
  },
};
